/* eslint-disable @typescript-eslint/no-unused-vars */
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable, Inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import _get from 'lodash-es/get';
import { TokenValidatorService } from '../services/token-validator/token-validator.service';
import { APP_CONFIG } from '../tokens/app-config.token';
import { Environment } from '../../../environments/environment.interface';
import { getValidAuthToken } from '../ngrx/state/auth.state';
import { ApplicationState } from '../../reducers';
import { getConstants } from '../constants/constants';
import { isSafeRedirectUrl } from '../../utils/isSafeRedirectUrl';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  constructor(
    private readonly tokenValidatorService: TokenValidatorService,
    private readonly store: Store<ApplicationState>,
    @Inject(APP_CONFIG) private readonly appConfig: Environment,
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.store.select(getValidAuthToken).pipe(
      map((codeToken) => {
        if (this.tokenValidatorService.isTokenValid(codeToken)) {
          const queryParams = _get(next, 'queryParams');
          const constants = getConstants(this.appConfig);
          const redirectUrl = new URLSearchParams(queryParams).get(constants.REDIRECT_KEY) || '';
          if (redirectUrl && isSafeRedirectUrl(redirectUrl, this.appConfig)) {
            window.location.href = redirectUrl;
          } else {
            window.location.href = this.appConfig.platform_url;
          }
          return false;
        }
          return true;
      }),
    );
  }
}
